import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IonCol, IonLabel } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { PayrollCategoryName } from '@wilson/interfaces';
import { map, merge, share, skip, switchMap, withLatestFrom } from 'rxjs';
import { WorkTimeManagementDataService } from '../../../work-time-management-data/work-time-management-data.service';
import { WorkingTimeDashboardContextService } from '../working-time-dashboard/working-time-dashboard-context.service';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { WorktimeMetricsCardComponent } from '../worktime-metrics-card/worktime-metrics-card.component';

@Component({
  selector: 'wilson-working-time-bonuses',
  templateUrl: './working-time-bonuses.component.html',
  styleUrls: ['./working-time-bonuses.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    WorktimeMetricsCardComponent,
    SectionWrapperComponent,
    IonLabel,
    IonCol,
  ],
})
export class WorkingTimeBonusesComponent {
  private readonly dashboardContext = inject(
    WorkingTimeDashboardContextService,
  );
  private readonly workTimeManagementDataService = inject(
    WorkTimeManagementDataService,
  );

  protected PayrollCategoryName = PayrollCategoryName;
  protected readonly isLoadingBonuses = signal(false);
  protected readonly hasError = signal(false);

  private readonly fetchTrigger$ = merge(
    this.dashboardContext.monthYear$.pipe(
      map((monthYear) => ({ monthYear, refresh: false as const })),
    ),
    this.dashboardContext.refreshTrigger$.pipe(
      skip(1),
      withLatestFrom(this.dashboardContext.monthYear$),
      map(([, monthYear]) => ({ monthYear, refresh: true as const })),
    ),
  ).pipe(share());

  protected readonly bonusesSignal = toSignal(
    this.fetchTrigger$.pipe(
      switchMap(({ monthYear, refresh }) =>
        this.workTimeManagementDataService.getWorktimeBonusesSummary({
          month: monthYear,
          isLoading: this.isLoadingBonuses,
          hasError: this.hasError,
          refresh,
        }),
      ),
    ),
    { initialValue: [] },
  );
}
